/* global jQuery, DLSPH_ALUMNI */
jQuery( $ => {
	const $body = $( 'body' );

	const today = new Date();
	let year = today.getFullYear();
	let month = today.getMonth() + 1;

	function getEvents( args, success ) {
		$.ajax( {
			url: DLSPH_ALUMNI.calendar_url,
			data: {
				action: 'events_calendar',
				...args,
			},
			type: 'GET',
			dataType: 'html',
			success( html ) {
				success( $( html ) );
			},
		} );
	}

	$( '#upcoming_events' ).each( function() {
		getEvents( {
			upcoming: true,
			count: 4,
			include: [ 'events' ],
		}, $html => {
			$html.find( 'a' ).attr( 'target', '_blank' );
			$( this ).html( $html.find( '.event-list' ) );
		} );
	} );

	$( '#featured_events' ).each( function() {
		getEvents( {
			month,
			year,
			day: today.getDate(),
			include: [ 'events' ],
		}, $html => {
			if ( $html.find( '.no-events' ).length > 0 ) {
				$( this ).parent().remove();
				return;
			}

			$html.find( 'a' ).attr( 'target', '_blank' );
			$( this ).html( $html.find( '.event-list' ) );
		} );
	} );

	function loadCalendar() {
		$body.addClass( 'loading-calendar' );

		getEvents( {
			month,
			year,
			include: [ 'calendar', 'events' ],
		}, $html => {
			$body.removeClass( 'loading-calendar' );
			$html.find( 'a' ).attr( 'target', '_blank' );

			year = $html.find( '.events-calendar' ).data( 'year' );
			month = $html.find( '.events-calendar' ).data( 'month' );

			$( '#events_calendar' ).html( $html.find( '.events-calendar' ) );
			$( '#events_list' ).html( $html.find( '.event-list' ) );
		} );
	}

	$( '#events_calendar' ).each( function() {
		const $prev = $( '<button class="events-calendar-nav-prev">Previous Month</button>' );
		const $next = $( '<button class="events-calendar-nav-next">Next Month</button>' );

		loadCalendar();

		$prev.click( () => {
			month--;
			loadCalendar();
		} );

		$next.click( () => {
			month++;
			loadCalendar();
		} );

		$( '#calendar_nav' ).append( $prev ).append( $next );
	} ).on( 'click', '.events-calendar-day-number', function( e ) {
		const events = ( $( this ).parent().data( 'events' ) + '' ).split( ',' );
		let $matches = $( [] );
		let match;
		let matched = 0;

		if ( events.length > 0 ) {
			for ( let i = 0; i < events.length; i++ ) {
				match = document.getElementById( 'event' + events[ i ] );
				if ( match ) {
					matched++;
					$matches = $matches.add( match );
				}
			}
		}

		if ( matched ) {
			e.preventDefault();

			$( '.events-calendar-day' ).removeClass( 'active' );
			$( '.event-item' ).removeClass( 'focus' );

			$( this ).parent().addClass( 'active' );
			$matches.addClass( 'focus' );

			$( 'html,body' ).animate( { scrollTop: $( '#events_list' ).offset().top - $( '.header' ).height() } );
		}
	} );
} );
